import React, { useState } from "react";
import PropTypes from "prop-types";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FormMenu } from "../../../components/Buttons";
import ItemListManager from "../../../components/ItemListManager";
import UserTechDeviceForm from "./UserTechDeviceForm";
import { CoverText, TableEmptyMessage } from "../../../components/Utils";
import TablePageReport from "../../../components/TablePageReport";

const UserTechDeviceListPanel = (props) => {
  const { className, model, rows } = props;
  const [first, setFirst] = useState(0);

  const onPage = (event) => {
    setFirst(event.first);
  };

  const renderItemTable = (items) => {
    if (items.length === 0) {
      return (
        <CoverText>
          {"Ihnen wurden noch keine Technikergeräte zugewiesen"}
        </CoverText>
      );
    }
    const data = items.map((item) => {
      const copy = JSON.parse(JSON.stringify(item));
      return { ...copy };
    });
    return (
      <DataTable
        value={data}
        rows={rows}
        paginator={data.length > rows}
        first={first}
        onPage={onPage}
        paginatorLeft={
          <TablePageReport
            className="pad-lft"
            totalRecords={data.length}
            filteredRecords={data.length}
            first={first}
            rows={rows}
            emptyText="Keine Geräte"
            itemName="Gerät"
            itemNamePlural="Geräte"
          />
        }
        emptyMessage={
          <TableEmptyMessage itemNamePlural="Technikergeräte" min />
        }
      >
        <Column
          field="device"
          header="Gerät"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
        <Column
          field="type"
          header="Typ"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
        <Column
          field="serialNumber"
          header="Seriennummer"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
      </DataTable>
    );
  };

  const renderItemForm = (item, onHide) => {
    const userTechDevice = item;
    return (
      <div>
        <UserTechDeviceForm model={userTechDevice} readonly />
        <FormMenu
          className="margin-big-top w3-border-top pad-big"
          style={{
            marginLeft: "-1em",
            marginRight: "-1em",
            marginBottom: "-1em",
          }}
          onCancel={onHide}
          saveDisabled
          saveBtnName="saveUserTechDeviceBtn"
        />
      </div>
    );
  };

  const getItemFormTitle = () => {
    return <h3 className="no-margin">{`Technikergerät ansehen`}</h3>;
  };

  return (
    <ItemListManager
      className={className}
      title={<h3 className="no-margin-top">VKDG Geräte / Technikergeräte</h3>}
      addBtnHidden
      items={model}
      getItemFormTitle={getItemFormTitle}
      renderItemTable={renderItemTable}
      renderItemForm={renderItemForm}
      namePrefix="userTechDevice"
    />
  );
};

UserTechDeviceListPanel.propTypes = {
  className: PropTypes.string,
  model: PropTypes.array,
  rows: PropTypes.number,
};

UserTechDeviceListPanel.defaultProps = {
  className: "",
  model: [],
  rows: 10,
};

export default UserTechDeviceListPanel;
